<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Persönlicher Support</h1>
                <p class="h2">Wenn Nutzende nicht sicher sind, was sie tun sollen, steht ihnen ihr persönlicher Berater oder ihre persönliche Beraterin jederzeit im Chat zur Verfügung.</p>
            </div>
            <div class="right-wrapper">
                <h2>Hilfe bei Bedarf</h2>
                <p class="text">Das Gefühl, unterstützt zu werden, hat einen großen Einfluss auf die Fähigkeit, Ziele zu erreichen. Wenn wir uns unterstützt fühlen, sind wir stärker motiviert, fühlen uns sicherer und übernehmen mehr Verantwortung. Die Berater:innen leiten an, ermutigen und helfen den Nutzenden dabei, Hindernisse zu überwinden und auf dem richtigen Weg zu bleiben.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 19
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

